// extracted by mini-css-extract-plugin
export default {"menu":"index_menu_yB22Q","menu_w1000":"index_menu_w1000_s-s6G","logo":"index_logo_IGRbc","menu_r":"index_menu_r_dmNoB","active":"index_active_xcvym"};